import { Button } from '@hologram-dimension/button';
import { Icon } from '@hologram-dimension/icon';
import { Link } from '@hologram-dimension/link';
import _classNames from 'clsx';
import * as alertTypes from 'common-js/constants/alertTypes';
import { ACTIONS_ALERTS_DEVICE_TACCHANGE, withContext } from 'common-js/constants/paths';
import { setSeenFleetHome } from 'common-js/reducers/account/actions';
import { getAlertCountByType } from 'common-js/reducers/alerts/actions';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class FleetHomeEyebrow extends Component<any, any, any> {
  today: any;

  constructor(props) {
    super(props);
    this.today = new Date()
      .toLocaleString([], {
        month: 'long',
        day: 'numeric',
        timeZoneName: 'short',
        hour: 'numeric',
        minute: 'numeric',
      })
      .replace(',', ' at');
    this.state = {
      alertCount: null,
    };
  }

  componentDidMount() {
    const { hasSeenFleetHome, setSeenFleetHome_, showInflight, getAlertCountByType_ } = this.props;

    if (showInflight) {
      Promise.all([
        getAlertCountByType_(alertTypes.DEVICE_DATA_LIMIT),
        getAlertCountByType_(alertTypes.DEVICE_USAGE),
        getAlertCountByType_(alertTypes.TAC_CHANGE),
      ]).then((res) => {
        this.setState({ alertCount: res[0] + res[1] + res[2] });
      });
    }

    if (!hasSeenFleetHome) {
      setTimeout(() => {
        setSeenFleetHome_(true);
      }, 1000);
    }
  }

  render() {
    const { firstName, hasSeenFleetHome, showInflight } = this.props;
    const { alertCount } = this.state;
    const welcomeMessage = `Here's your snapshot for ${this.today}`;

    return (
      <div className="FleetHomeEyebrow">
        <span
          className={_classNames({
            FleetHomeEyebrow__header: !hasSeenFleetHome,
            'FleetHomeEyebrow__header--secondary': !hasSeenFleetHome,
            FleetHomeEyebrow__subheader: hasSeenFleetHome,
          })}
        >
          {showInflight ? welcomeMessage : `Welcome back, ${firstName}`}
        </span>
        <div className="FleetHomeEyebrow__header__container">
          {showInflight ? (
            <div
              className={_classNames('FleetHomeEyebrow__header FleetHomeEyebrow__header--alerts', {
                'FleetHomeEyebrow__header--hidden': !hasSeenFleetHome,
              })}
            >
              <div className="FleetHomeEyebrow__header--alerts__left">
                <Icon name="ActionItem" size="large" fill="DdsColorPalettePurple75" />
                <h2 className="FleetHomeEyebrow__header__alert-headline">
                  You have
                  <Link
                    to={withContext(ACTIONS_ALERTS_DEVICE_TACCHANGE)}
                    className="FleetHomeEyebrow__header__alert-headline__highlight"
                    type="inline"
                    inverse
                  >
                    {`${alertCount} total Action items `}
                  </Link>
                  to review
                </h2>
              </div>
              <div className="FleetHomeEyebrow__header--alerts__right">
                <Button
                  to={withContext(ACTIONS_ALERTS_DEVICE_TACCHANGE)}
                  iconEnd="ArrowEastShort"
                  variant="secondary"
                  inverse
                >
                  Review action items
                </Button>
              </div>
            </div>
          ) : (
            <span
              className={_classNames('FleetHomeEyebrow__header', {
                'FleetHomeEyebrow__header--hidden': !hasSeenFleetHome,
              })}
            >
              {welcomeMessage}
            </span>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSeenFleetHome_: setSeenFleetHome,
      getAlertCountByType_: getAlertCountByType,
    },
    dispatch
  );

export default connect(() => ({}), mapDispatchToProps)(FleetHomeEyebrow);
